<template>
  <div id="hzhb">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hzhb'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/setup/hzhb/Hzhb.vue